import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ptBR } from 'date-fns/locale';
import { parseISO, format, isValid } from 'date-fns';

/**
 * DateField — input de data centralizado no padrão brasileiro (dd/mm/aaaa).
 *
 * Props:
 *   label        string
 *   value        string  — formato ISO "YYYY-MM-DD" (ou '')
 *   onChange     (isoString: string) => void — sempre devolve "YYYY-MM-DD" ou ''
 *   [qualquer prop extra do TextField do MUI]
 *
 * NÃO use <TextField type="date"> diretamente — veja regra ESLint no-restricted-syntax.
 */
export default function DateField({ label, value, onChange, ...rest }) {
  const parsed = value ? parseISO(value) : null;
  const dateValue = parsed && isValid(parsed) ? parsed : null;

  const handleChange = (newDate) => {
    if (!newDate || !isValid(newDate)) {
      onChange('');
    } else {
      onChange(format(newDate, 'yyyy-MM-dd'));
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <DatePicker
        label={label}
        value={dateValue}
        onChange={handleChange}
        format="dd/MM/yyyy"
        slotProps={{
          textField: {
            fullWidth: true,
            ...rest,
          },
        }}
      />
    </LocalizationProvider>
  );
}
